import {
	SEARCH_COACHES_ACTION_TYPES,
	SearchCoachesState,
	SetCoachesAction,
} from '../../../types/coaches'

const initialState: SearchCoachesState = {
	coachesDataArray: [],
	selectedAssignCoach: [],
	selectedCoach: {
		_id: '',
		employment: {
			expertise: [],
			patientCapacityLoad: 0,
			roleTypes: [],
			roles: [],
			skills: [],
			startOfService: '',
			title: 0,
		},
		extra: {
			active: false,
			auth0UserId: '',
			coachId: '',
			firstLogin: false,
			firstPassword: '',
			organizationID: '',
		},
		localization: {
			carbs: '',
			dateConfiguration: '',
			glucoseLevel: '',
			language: '',
			temperature: '',
			weightHeight: '',
		},
		numOfPatients: 0,
		organizations: [],
		personal: {
			cvUrl: '',
			dateOfBirth: '',
			email: '',
			gender: '',
			imageUrl: '',
			name: '',
			phone: '',
		},
		email: '',
		ID: '',
		account: '',
	},
	historyLogCoach: [],
	coachHistorySearch: '',
	historyLogCoachRequest: {
		userId: '',
		skip: {
			1: 0,
			2: 0,
		},
		sort: {
			timestamp: -1,
		},
	},
	coachAssignSearch: '',
	selectedCoachId: '',
	assignCoachesLoading: false,
}

export default (
	state = initialState,
	action: SetCoachesAction
): SearchCoachesState => {
	switch (action.type) {
		case SEARCH_COACHES_ACTION_TYPES.GET_ALL_COACHES: {
			return {
				...state,
				coachesDataArray: action.payload,
			}
		}
		case SEARCH_COACHES_ACTION_TYPES.GET_COACH: {
			return {
				...state,
				selectedCoach: action.payload,
			}
		}
		case SEARCH_COACHES_ACTION_TYPES.SELECTED_ASSIGN_COACH: {
			return {
				...state,
				selectedAssignCoach: action.payload,
			}
		}
		case SEARCH_COACHES_ACTION_TYPES.GET_COACH_HISTORY_LOG: {
			return {
				...state,
				historyLogCoach: action.payload,
			}
		}
		case SEARCH_COACHES_ACTION_TYPES.GET_COACH_HISTORY_LOG_SERCH: {
			return {
				...state,
				coachHistorySearch: action.payload,
			}
		}
		case SEARCH_COACHES_ACTION_TYPES.SET_ASSIGN_COACH_SEARCH_VALUE: {
			return {
				...state,
				coachAssignSearch: action.payload,
				selectedCoachId: '',
			}
		}
		case SEARCH_COACHES_ACTION_TYPES.ASSIGN_COACH_SELECT: {
			return {
				...state,
				selectedCoachId: action.payload,
			}
		}
		case SEARCH_COACHES_ACTION_TYPES.ASSIGN_COACH_LOADING: {
			return {
				...state,
				assignCoachesLoading: action.payload,
			}
		}
		case SEARCH_COACHES_ACTION_TYPES.ASSIGN_COACH_RESET: {
			return initialState
		}
		default: {
			return state
		}
	}
}
